import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';

function ReleaseTestCrud({ form, handleFinish, services = [], environments = [] }) {
  const ServiceWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select service' options={services} allowClear />
  );

  const EnvironmentWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select environment' options={environments} allowClear />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'name', label: 'Suite Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. User API Smoke Tests' } },
      { key: 'service', label: 'Service', colSpan: 2, widget: ServiceWidget, forwardRef: true, required: true },
      { key: 'environment', label: 'Environment', colSpan: 2, widget: EnvironmentWidget, forwardRef: true },
      { key: 'timeout', label: 'Timeout (s)', colSpan: 1, widget: KoInput, widgetProps: { placeholder: '30', type: 'number' } },
      { key: 'retryCount', label: 'Retries', colSpan: 1, widget: KoInput, widgetProps: { placeholder: '0', type: 'number' } },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'Test suite description...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default ReleaseTestCrud;
